import { Component, OnInit } from '@angular/core';
import { AuthFacade } from '@tvt-logistics-india/data-access';

@Component({
  selector: 'tvt-logistics-india-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  constructor(public authFacade: AuthFacade) {}

  ngOnInit(): void {}

  onSubmit(username, password, email, role) {
    if (username.value && password.value && email.value && role.value) {
      this.authFacade.signUp(
        username.value,
        password.value,
        email.value,
        role.value
      );
    }
  }
}
